import GoogleAnalytics4 from './GoogleAnalytics4';

export default class Analytics {
  static viewDetailProduct(product) {
    if (product) {
      GoogleAnalytics4.viewItem({ ...product });
    }
  }

  static viewProductList(products) {
    if ((Array.isArray(products), products?.length)) {
      GoogleAnalytics4.viewItemList(products);
    }
  }

  static addToBasket(product) {
    if (product) {
      GoogleAnalytics4.addToCart({ ...product });
    }
  }

  static removeFromBasket(product) {
    if (product) {
      GoogleAnalytics4.removeFromCart({ ...product });
    }
  }

  static showBasket(products) {
    if (products?.length) {
      GoogleAnalytics4.ViewCart(products);
    }
  }

  static clickOnProduct(product) {
    if (product) {
      GoogleAnalytics4.selectItem(product);
    }
  }

  static viewCheckout(items) {
    try {
      if (!items) return;

      const products = Object.values(items);

      if (products) {
        GoogleAnalytics4.beginCheckout(products);
      }
    } catch (err) {
      console.error(err);
    }
  }

  static confirmCheckout(items, generalData) {
    if (items) {
      GoogleAnalytics4.purchase(items, generalData);
    }
  }

  static buyOneClick(items, generalData) {
    const products = Object.values(items);

    if (products) {
      GoogleAnalytics4.purchase(products, generalData);
    }
  }
}
